module.exports = __webpack_public_path__ + "static/media/20240530090058_IMG_7495.a68aa219.JPG";